/*jslint browser */
/*global process */

var $ = jQuery;

export default class imageCombiner {
    private _canvasId: string;
    private _canvas: HTMLCanvasElement;
    private _context: any;

    constructor(canvasId: string) {
        if(canvasId) {
            this._canvasId = canvasId;
            this._canvas = $('#' + this._canvasId).get(0) as HTMLCanvasElement;
            if(this._canvas !== undefined) {
                // @ts-ignore
                this._context = this._canvas.getContext("2d");
            }
        }
    }

    public setCanvasWidth(width: number) {
        // @ts-ignore
        this._canvas.width = width;
    }

    public setCanvasHeight(height: number) {
        // @ts-ignore
        this._canvas.height = height;
    }

    public getImageUrl() {
        // @ts-ignore
        return this._canvas.toDataURL("image/png");
    }

    public clearCanvas() {
        // @ts-ignore
        this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    }

    // @ts-ignore
    public drawImage(image: CanvasImageSource) {
        this._context.drawImage(image, 0, 0);
    }

    public imageReflection() {
        // @ts-ignore
        const imageObj = new Image();
        imageObj.src = this.getImageUrl();

        const context = this._context;
        const canvas = this._canvas;

        imageObj.onload = function () {
            // @ts-ignore
            context.translate(canvas.width, 0);
            context.scale(-1, 1);
            context.drawImage(imageObj, 0, 0);
        };
    }

    public imageReflectionFromSource(source: any) {
        // @ts-ignore
        const imageObj = new Image();
        imageObj.src = source.getImageUrl();

        const context = this._context;
        const canvas = this._canvas;

        imageObj.onload = function () {
            context.save();
            // @ts-ignore
            context.translate(canvas.width, 0);
            context.scale(-1, 1);
            context.drawImage(imageObj, 0, 0);
            context.restore();
        };
    }

    /*Wywołanie
    const img = combiner.combineImages(srcImage1, srcImage2);
    img.then(result => {result});
    });*/
    public async combineImages(srcImage1: string, srcImage2: string = '') {
        // @ts-ignore
        const imageObj1 = new Image();
        // @ts-ignore
        const imageObj2 = new Image();
        const context = this._context;
        const canvas = this._canvas;
        let resultImg = '';

        const imageRenderPromise = new Promise(resolve => {
            imageObj1.src = srcImage1;
            imageObj1.onload = function () {
                context.drawImage(imageObj1, 0, 0);
                if (srcImage2 != '') {
                    imageObj2.src = srcImage2;
                    imageObj2.onload = function () {
                        context.drawImage(imageObj2, 0, 0);
                        // @ts-ignore
                        resultImg = canvas.toDataURL("image/png");
                        resolve('ok');
                    }
                } else {
                    resolve('ok');
                }
            };
        });

        await imageRenderPromise;
        return resultImg;
    }
}